module.exports = "<p>\n  marketing works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/business-units/marketing/marketing.component.html
// module id = ./src/app/web/game/management/business-units/marketing/marketing.component.html
// module chunks = main